import {Redirect, Route, Switch} from "react-router-dom";
import {isLoggedIn, logOut, validateAndRefreshToken} from "../../common/actions/authentication.js";

import AccountSettingsContainer from "../containers/AccountSettingsContainer.jsx";
import CampaignsContainer from "../containers/CampaignsContainer.jsx";
import ComponentsColor from "../../common/components/ComponentsColor.jsx";
import ComponentsShowCase from "../../common/components/ComponentsShowCase.jsx";
import DashboardContainer from "../../kundeweb/containers/dashboardContainer.jsx";
import DominosContainer from "../../dominosweb/containers/DominosContainer.jsx";
import EditMyListContainer from "../containers/EditMyListContainer.jsx";
import FreshFoodTemplateContainer from "../containers/FreshFoodTemplateContainer.jsx";

import HelpFaqContainer from "../containers/HelpFaqContainer.jsx";
import HistoryClaimContainer from "../containers/history/HistoryClaimContainer.jsx";
import HistoryTabsContainer from "../containers/history/HistoryTabsContainer.jsx";
import HubOverviewContainer from "../../hubweb/containers/HubOverviewContainer.jsx";
import HubProductionContainer from "../../hubweb/containers/HubProductionContainer.jsx";
import MultiChainContainer from "../../kjedeweb/containers/MultiChainContainer.jsx";
import MultiEpixContainer from "../../kjedeweb/containers/MultiEpixContainer.jsx";
import MyListContainer from "../containers/MyListContainer.jsx";
import OrderProductsContainer from "../containers/OrderProductsContainer.jsx";
import Page404 from "../../common/components/Page404.jsx";
import PropTypes from "prop-types";
import React from "react";
import SingleChainContainer from "../../kjedeweb/containers/SingleChainContainer.jsx";
import SingleEpixContainer from "../../kjedeweb/containers/SingleEpixContainer.jsx";
import {checkIfWebSiteIsClosed} from "../../common/actions/authentication.js";
import {connect} from "react-redux";
import {loadAndShowLatestMustReadNotification} from "../../common/actions/notifications.js";


import {setCurrentLanguage} from "../../common/actions/userSettings.js";
import {withRouter} from "react-router-dom";

const mapStateToProps = state => ({
    authentication: state.authentication,
    deviceType: state.view.deviceType,
    localization: state.localization,
});
const mapDispatchToProps = {
    validateAndRefreshToken,
    loadAndShowLatestMustReadNotification,
    checkIfWebSiteIsClosed,
    logOut,
    setCurrentLanguage
};
class Routing extends React.Component{
    componentDidMount() {
        const minimumRemainingTokenValidityInSeconds = 60 * 5;
        this.validatingInterval = setInterval(() => this.props.validateAndRefreshToken(minimumRemainingTokenValidityInSeconds,this.props.history), 30000);

        if(!this.props.authentication.isChainLogin && !this.props.authentication.isHubLogin && !this.props.authentication.isDominosLogin)
        {
            this.loadNotificationsInterval = setInterval(() => {
                if (isLoggedIn(this.props.authentication)) {
                    this.props.loadAndShowLatestMustReadNotification();
                }
            }, 3 * 60 * 1000);
    
            if (isLoggedIn(this.props.authentication)) {
                this.props.loadAndShowLatestMustReadNotification();
            }
        }        

        if( !this.props.localization.hasData ){
            this.props.setCurrentLanguage("no");
        }

        // Set scan interval for web site closing
        this.webSitePollInterval = setInterval(() => {
            this.props.checkIfWebSiteIsClosed();
        },60 * 1000);
        
    }
    componentWillUnmount() {
        clearInterval(this.validatingInterval);
        clearInterval(this.loadNotificationsInterval);
    }
    render(){
        const {
            authentication,
            deviceType,
            history,
            logOut
        } = this.props;

        if( !isLoggedIn(authentication) ){
            return <Redirect to="/login"/>;
        }

        if ((authentication.isChainLogin || authentication.isHubLogin || authentication.isDominosLogin) && (deviceType === "xs" || deviceType === "sm" || deviceType === "md")) {
            return (
                <div>
                    <div className="dim-screen"/>
                    <div className="modal">
                        <div className="card-default" style={{
                            padding: "2rem"
                        }}>
                            <h4>Denne websiden støtter bare stasjonære datamaskiner.</h4>
                            {/* eslint-disable-next-line react/jsx-no-bind */}
                            <button className="btn primnary" onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                logOut(history);
                            }}>Logg ut</button>
                        </div>
                    </div>
                </div>
            );
        }

        return (authentication.isHubLogin ? (
            <Switch>
                <Route exact path="/hubweb/overview" component={HubOverviewContainer}/>
                <Route exact path="/hubweb/production" component={HubProductionContainer}/>
                <Redirect to="/hubweb/overview"/>
            </Switch>
        ) : (
            authentication.isDominosLogin ? (
                <Switch>
                    <Route exact path="/dominosweb/production" component={DominosContainer}/>
                    <Redirect to="/dominosweb/production"/>
                </Switch>
            ) : (
                authentication.isChainLogin ? (
                    authentication.chainIds.length > 1 ? (
                        <Switch>
                            <Route exact path="/chainwebMulti/chainsortiment" component={MultiChainContainer}/>
                            <Route exact path="/chainwebMulti/epixsortiment" component={MultiEpixContainer}/>
                            <Redirect to="/chainwebMulti/chainsortiment"/>
                        </Switch>
                    ) : (
                        <Switch>
                            <Route exact path="/chainwebSingle/chainsortiment/:view" component={SingleChainContainer}/>
                            <Route exact path="/chainwebSingle/epixsortiment/:view"  component={SingleEpixContainer}/>
                            <Redirect to="/chainwebSingle/chainsortiment/all"/>
                        </Switch>
                    )) : (
                    <Switch>
                        <Route exact path="/" component={DashboardContainer}/>
                        <Route exact path="/dashboard" component={DashboardContainer}/>
                        <Route exact path={"/history/claim/:invoiceId/:view"} component={HistoryClaimContainer}/>
                        <Route path={"/history/"} component={HistoryTabsContainer}/>
                        {(process.env.NODE_ENV !== "production") && (
                            <Route exact path={"/components"} component={ComponentsShowCase} />
                        )}
                        <Route exact path={"/order/products"} component={OrderProductsContainer}/>
                        <Route exact path={"/order/products/:view"} component={OrderProductsContainer}/>
                        <Route exact path={"/order/lists"} component={MyListContainer} />
                        <Route exact path={"/order/campaigns"} component={CampaignsContainer} />
                        <Route exact path={"/order/freshfoodTemplate"} component={FreshFoodTemplateContainer} />
                        <Route exact path={"/order/lists/edit/:listId"} component={EditMyListContainer} />
                        <Route exact path={"/order/lists/edit/:listId/:view"} component={EditMyListContainer} />
                        {(process.env.NODE_ENV !== "production") && (
                            <Route exact path={"/components/products"} component={ComponentsShowCase} />
                        )}
                        {(process.env.NODE_ENV !== "production") && (
                            <Route exact path={"/components/fresh"} component={ComponentsShowCase} />
                        )}
                        <Route exact path={"/help/faq"} component={HelpFaqContainer} />
                        <Route path={"/account_settings"} component={AccountSettingsContainer}/>
                        {(process.env.NODE_ENV !== "production") && (
                            <Route path={"/color"} component={ComponentsColor} />
                        )}
                        <Route component={Page404} />
                    </Switch>
                ))));
    }
}
Routing.propTypes = {
    authentication: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    validateAndRefreshToken: PropTypes.func.isRequired,
    setCurrentLanguage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    localization: PropTypes.object,
    logOut: PropTypes.func.isRequired,
    loadAndShowLatestMustReadNotification: PropTypes.func.isRequired,
    checkIfWebSiteIsClosed: PropTypes.func.isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Routing));